import { createContext, useContext, type ReactNode } from 'react';
import { systemClock, toBusinessDate, type BusinessDate, type Clock } from '@crm/shared/time';
import { BUSINESS_TIMEZONE } from './config.ts';

/** The time source of the UI. Tests inject a fixed clock instead of calling `new Date()`. */
const ClockContext = createContext<Clock>(systemClock);

export function ClockProvider({ clock, children }: { clock: Clock; children: ReactNode }) {
  return <ClockContext.Provider value={clock}>{children}</ClockContext.Provider>;
}

export const useClock = (): Clock => useContext(ClockContext);

/** Today's business date in the business time zone. */
export function useToday(): BusinessDate {
  return toBusinessDate(useClock().now(), BUSINESS_TIMEZONE);
}
